// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"apps_consumer_src_bootstrap_ts":"ba6726bd1a701c02","node_modules_ngx-quill_fesm2022_ngx-quill-quill-Di9aaYtq_mjs":"84af0cb7014cdf66","libs_rsf-sdk_src_index_ts":"9d429185aff70d3c"}[chunkId] + ".js";
};